export class PrizeSlot {
    id: number;
    name: string;
    container: string;
    image: string;
    ticketValue: number;
    prizeCost: number;
    maxQuantity: number;
    remainingQuantity: number;
    lowQuantityThreshold: number;
    prizeStatus: string;
    saleTicketValue: number;
    saleStartDate: Date;
    saleEndDate: Date;
    syncState: string;
    machineId: string;
    description: string;
    saleDuration: string;

    fromJson(dict: any): PrizeSlot {
        this.id = dict.id;
        this.name = dict.name;
        this.container = dict.container;
        this.image = dict.image;
        this.ticketValue = dict.ticketValue;
        this.prizeCost = dict.prizeCost;
        this.maxQuantity = dict.maxQuantity;
        this.remainingQuantity = dict.remainingQuantity;
        this.lowQuantityThreshold = dict.lowQuantityThreshold || 0;
        this.prizeStatus = dict.prizeStatus;
        this.saleTicketValue = dict.saleTicketValue;
        this.saleStartDate = dict.saleStartDate || null;
        this.saleEndDate = dict.saleEndDate || null;
        this.syncState = dict.syncState;
        this.machineId = dict.machineId;
        this.description = dict.description;
        this.saleDuration = dict.saleDuration;

        return this;
    }

    fromJsonArray(array: any[]): PrizeSlot[] {
        let ret: PrizeSlot[] = [];
        array.forEach((dict) => {
            ret.push(new PrizeSlot().fromJson(dict));
        });
        return ret;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/prize-slot.ts